
let language = {
    SET_AS_SHARE_FILE_SHARE_ROOT_TITLE: "Set as share root folder",
    SET_AS_SHARE_FILE_WHETHER_MIGRATE: "Whether to migrate data from the old folder to the new folder?",
    SET_AS_SHARE_FILE_NEED_MIGRATE: "needMigrate",
    
    // 
    SET_AS_SHARE_FILE_CANCEL_BTN: "cancel",
    SET_AS_SHARE_FILE_OK_BTN: "ok",
};

export { language }